import { openWith, popupMessageHidden, popupMessageShown } from './core'

export const $$popup = {
  openWith,
  hide: popupMessageHidden,
  show: popupMessageShown,
}
